// Kind of like Python's defaultdict
export class DefaultMap<K, V> extends Map<K, V> {
  private factory: (k: K) => V;
  constructor(factory: (k: K) => V) {
    super();
    this.factory = factory;
  }

  get(k: K): V {
    if (this.has(k)) {
      return super.get(k) as V;
    }
    const v = this.factory(k);
    this.set(k, v);
    return v;
  }

  toMap(): Map<K, V> {
    return new Map(this);
  }
}
